export default __webpack_public_path__ + "static/media/3146.f9aa9fa3.jpg";